import "./HelpCenterNavTree.scss"

import { useMemo } from "react"

import { HelpCenterNavTreeProps, WikiNavItem } from "../../types"
import HelpCenterNavItem from "../HelpCenterNavItem/HelpCenterNavItem"

function HelpCenterNavTree(props: HelpCenterNavTreeProps) {
  const { items, activeSectionId, onNavigate, searchQuery, currentPath, level = 0 } = props

  const filteredItems = useMemo(() => {
    if (!searchQuery.trim()) return items

    const query = searchQuery.toLowerCase()

    function filterItems(items: WikiNavItem[]): WikiNavItem[] {
      return items.reduce<WikiNavItem[]>((acc, item) => {
        const labelMatches = item.label.toLowerCase().includes(query)
        const keywordsMatch = item.searchKeywords?.some(kw =>
          kw.toLowerCase().includes(query)
        )

        const filteredChildren = item.children ? filterItems(item.children) : []

        if (labelMatches || keywordsMatch || filteredChildren.length > 0) {
          acc.push({
            ...item,
            children: filteredChildren.length > 0 ? filteredChildren : item.children
          })
        }

        return acc
      }, [])
    }

    return filterItems(items)
  }, [items, searchQuery])

  const isFiltered = searchQuery.trim().length > 0

  return (
    <ul className="help-center-nav-tree">
      {filteredItems.map(item => (
        <HelpCenterNavItem
          key={item.id}
          item={item}
          activeSectionId={activeSectionId}
          onNavigate={onNavigate}
          currentPath={currentPath}
          level={level}
          isFiltered={isFiltered}
        />
      ))}
    </ul>
  )
}

export default HelpCenterNavTree
